import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useSearchParams } from 'react-router-dom'
import RegionItem from '../../components/snp-page/region-item.component'
import { useTranslation } from 'react-i18next'
import { getLang } from '../../utils/helpers.utils'
import { getFilteredTree } from '../../requests/supervisor.request'
import { getStatistics } from '../../requests/kato.request'
import {  OBLAST_KATO } from '../../constants/snp.constant'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  max-height: 85vh;
  overflow-y: auto;
  padding-right: 0.625rem;

  ::-webkit-scrollbar {
    width: 2px;
    margin-right: 0.625rem;
  }
  
  ::-webkit-scrollbar-track {
    background-color: transparent; 
    margin-right: 0.625rem;

  }
  
  ::-webkit-scrollbar-thumb {
    background-color: var(--gray);
    border-radius: 5px; 
    border-top: 15px solid transparent;
    border-bottom: 35px solid transparent;
    background-clip: padding-box;
  }
`

const SnpPage = () => {
  const [searchText, setSearchText] = useState('');
  const [searchParams] = useSearchParams();
  const [listOptions, setListOptions] = useState<any[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<any[]>([]);
  const [katoAccessList, setKatoAccessList] = useState<number[]>([]);
  const [statistics, setStatistics] = useState<any>(null);
  const { i18n: { language } } = useTranslation();

  const navigate = useNavigate();

  const getOptions = () => {
    getFilteredTree()
      .then((res: any) => {
        const list = res.list.sort((a: any, b: any) => a[`name${getLang()}`].localeCompare(b[`name${getLang()}`]));
        setListOptions(list);
        setFilteredOptions(list);
      })
  }

  const handleClick = (item: any) => {
    navigate(`/admin/${item.kato}`, { state: { item } });
  }

  useEffect(() => {
    getOptions()
  }, [language])


  useEffect(() => {
    setSearchText(searchParams.get('searchText') || '');
  }, [searchParams])

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData !== undefined && userData !== 'undefined') {
      const snpInfo = JSON.parse(userData || '');
      if (snpInfo && snpInfo.kato_access) {
        setKatoAccessList(snpInfo.kato_access)
      }
    }

    getStatistics()
      .then((res) => {
        setStatistics(res[OBLAST_KATO]);
      })
  }, [])

  useEffect(() => {
    if (listOptions) {
      const filteredData = listOptions.map((region) => {
        const matchingDistricts = region.children.filter((district: any) =>
          district[`name${getLang()}`].toLowerCase().includes(searchText.toLowerCase())
        );

        if (matchingDistricts.length > 0) {
          return {
            ...region,
            children: matchingDistricts,
          };
        }

        return null;
      }).filter(Boolean);
      setFilteredOptions(filteredData);
    }
  }, [listOptions, searchText])


  return (
    <Wrapper>
      {statistics && <>
        {katoAccessList.includes(0) && <RegionItem
          region={{ kato: OBLAST_KATO, nameRu: 'Туркестанская область', nameKz: 'Түркістан облысы', statistics } as any}
          onClick={handleClick}
          isEditable={katoAccessList.includes(0)}
        />}
        {/* {(katoAccessList.includes(0) || katoAccessList.includes(cityObject.kato)) && <RegionItem
          region={{ ...cityObject, statistics: [] } as any}
          onClick={handleClick}
          isEditable={katoAccessList.includes(0) || katoAccessList.includes(cityObject.kato)}
        />} */}
      </>}
      {
        filteredOptions && filteredOptions?.length > 0 && filteredOptions?.map((item) =>
          <RegionItem
            key={item.kato}
            region={item}
            onClick={handleClick}
            isEditable={katoAccessList.includes(+item.kato) || katoAccessList.includes(0)}
          />
        )
      }
    </Wrapper>
  )
}

export default SnpPage